import axios from 'axios';
import dayjs from 'dayjs';
import { store } from 'store';

import { apiAuthenticateHandoff, apiAuthenticateSession } from '~constants/api';

import { set as setLocal } from '~libs/localstorage';

import { removeAuthenticated, setForceRedirect, setSessionToken } from '~main/reducers/login';

// Endpoints whose job is to establish a session from a cross-application credential.
// A 401 from one of these means the credential just presented was no good - a spent
// single-use handoff ticket, say - NOT that the caller's existing session has expired.
// Clearing the session here would sign a user out for replaying a stale link, which is
// an ordinary thing to do (pressing Back through a handoff lands on one). Leave the
// session intact and let the caller decide what to do.
const AUTH_ATTEMPT_PATHS = [apiAuthenticateHandoff, apiAuthenticateSession];

const isAuthAttempt = (url?: string) => Boolean(url) && AUTH_ATTEMPT_PATHS.some((path) => url?.includes(path));

export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (request) => {
      const token = store.getState().main.login.sessionToken;
      if (token) {
        request.headers['x-session-token'] = token;
      }
      request.headers['UTC-Offset'] = dayjs().format('ZZ');
      return request;
    },
    (error) => error,
  );

  axios.interceptors.response.use(
    (response) => {
      const token = response.headers['x-session-token'];
      if (token) {
        store.dispatch(setSessionToken(token));
        setLocal('x-session-token', token);
      }
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        const { data } = error.response;
        if (data.reason === 'company-disabled') store.dispatch(setForceRedirect());
        if (!isAuthAttempt(error.config?.url)) store.dispatch(removeAuthenticated());
      }
      return Promise.reject(error);
    },
  );
};
